import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _checkoutBrand = { header: '_checkoutHeader' };
var _checkoutHeader = { logo: '_logo' };
var _checkoutSettings = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    checkoutBrand: '_checkoutBrand',
};
var _ecommerceSettings = { checkout: '_checkoutSettings' };
var _focalPoint = { x: 'DOUBLE', y: 'DOUBLE' };
var _getEcommerceSettingsRequest = {};
var _getEcommerceSettingsResponse = {
    ecommerceSettings: '_ecommerceSettings',
};
var _image = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    focalPoint: '_focalPoint',
};
var _logo = { image: '_image' };
function resolveWixEcomEcommerceSettingsV1EcommerceSettingsServiceUrl(opts) {
    var domainToMappings = {
        _: [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/_api/ecommerce-settings',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves site eCommerce settings. */
export function getEcommerceSettings(payload) {
    var _a = serializer(_getEcommerceSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getEcommerceSettingsResponse, {
        _checkoutBrand: _checkoutBrand,
        _checkoutHeader: _checkoutHeader,
        _checkoutSettings: _checkoutSettings,
        _ecommerceSettings: _ecommerceSettings,
        _focalPoint: _focalPoint,
        _image: _image,
        _logo: _logo,
    }).fromJSON;
    function __getEcommerceSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.ecom.v1.ecommerce_settings',
            method: 'GET',
            methodFqn: 'wix.ecom.ecommerce_settings.v1.EcommerceSettingsService.GetEcommerceSettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixEcomEcommerceSettingsV1EcommerceSettingsServiceUrl({
                protoPath: '/v1/ecommerce-settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getEcommerceSettings.fromReq = fromReq;
    __getEcommerceSettings.__isAmbassador = true;
    return __getEcommerceSettings;
}
//# sourceMappingURL=http.impl.js.map